import { render, staticRenderFns } from "./PricePanelFormItems.vue?vue&type=template&id=a2d794de"
import script from "./PricePanelFormItems.vue?vue&type=script&lang=js"
export * from "./PricePanelFormItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports